import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';

import ModalOrder from '../components/modal_order/modal_order'
import ModalOrderConfirmation from '../components/modal_order/modal_order_confirmation'
import ModalPlaceOrderNotValid from '../components/modal_order/modal_place_order_not_valid'
import ModalPlaceOrderNotValid2 from '../components/modal_order/modal_place_order_not_valid2'
import ModalPlaceOrderWithReplace from '../components/modal_order/modal_place_order_with_replace'
import UpperMenu from '../components/upper_menu/upper_menu.component'
import SearchPanelResults from '../components/search_panel_results/search_panel_results.conponent'
import TitleListHotels from '../components/title_list_hotels/titleListHotels.component'
//import HotelsForOrderList from '../components/hotels_for_order/hotels_for_order_list.component'
import HotelsForOrderList from '../components/hotels_for_order2/hotels_for_order_list.component'
import compose from '../utils/compose'
import {getToken,getSToken} from '../utils/token'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import Spinner from 'react-bootstrap/Spinner'
import ModalHotelDetails from '../components/hotels_list/modal_hotel_details.component'
import { Redirect  } from "react-router-dom";

class ResultsPage extends Component {

  state = {
    redirect: null,
    loading: true,
    modalDisplay:false,
    modalOrderDisplay:false,
    modalOrderWithReplaceDisplay : false,
    modalOrderConfirmationDisplay:false,
    modalPlaceOrderNotValid: false,
    modalPlaceOrderNotValid2: false,
    placeOrderData:{},
    placeOrderDataResult: {},
    makeOrderData:{},
    makeOrderDataResult : {},
    hotelsForOrder: [], 
    searchTitle:'',
    notvalid:1, 
    modalHotelDisplay:false,
    currentHotel:{},
    currentFacilities:{}
  }
    



  setModalClosed = () => {
    this.setState({ modalDisplay: false});
  }
  setModalOpened = () => {
    this.setState({ modalDisplay: true});
  }

  setModalOrderClosed = (placeOrderData) => {
    const { nofeshService } = this.props;
    const { personData }  = this.props;

    console.log('ResultsPage setModalOrderClosed',placeOrderData);
    nofeshService.placeOrderRemove(
      placeOrderData.hotelForOrder.AllocationId).then( res  => {      
      
      this.setState({ modalOrderDisplay: false});    
    }); 
  }
  
  setModalOrderOpened = () => {
    this.setState({ modalOrderDisplay: true});
  }

  setModalOrderConfirmationClosed = () => {
    this.setState({ modalOrderConfirmationDisplay: false});
  }

  setModalPlaceOrderNotValidClosed = () => {
    this.getSearchResults();
  }

  setModalPlaceOrderNotValidClosed2 = () => {
      this.setState({ modalPlaceOrderNotValid2: false});
  }

  changeSearchOrderPlaces = (obj) => {
    Object.assign(this.changeSearchOrderPlaces, obj);
  }        

  setModalOrderWithReplaceOpened = () => {
    this.setState({ modalOrderWithReplaceDisplay: true});
  }

  setModalOrderWithReplaceClosed= () => {
    this.setState({ modalOrderWithReplaceDisplay: false});
  }

  getSearchResults = () => {
    let serviceOp = true;
    const { currentSearchObj }  = this.props;
    const { nofeshService } = this.props;
    

    //setCurrentAppData

    nofeshService.getSearchHotelsForOrder(currentSearchObj).then( res  => {    
          console.log('ResultsPage  getSearchHotelsForOrder res.data: ', res.data);
          let  resultObj = res.data;
          if ( res.data.status == "1") {
            this.setState({hotelsForOrder: resultObj.hotelsForOrder}); 

            if(resultObj.hotelsForOrder.length == 0) {
              this.setState({searchTitle:'לא נמצאו תוצאות.'});
            } else {
              serviceOp = true;
              this.setState({searchTitle:'תוצאות חיפוש'});
            }
          }
          else {
             serviceOp = false;
          }
          this.setState({ modalPlaceOrderNotValid: false});
          this.setState({loading:false});     
          
    }).catch(function(error) {
        serviceOp = false;
        console.log('ResultsPage getSearchResults nofeshService ERROR: ',error);
    }).finally(() => {

      if (!serviceOp) 
      {
        this.setState({searchTitle:'לא נמצאו תוצאות.'})
        this.setState({ hotelsForOrder: [] });
      }
    });

  }


  componentDidMount = () => {
      console.log('ResultsPage componentDidMount props' ,this.props);
      console.log('ResultsPage componentDidMount loading: ' ,this.state.loading);
      this.getSearchResults();
  }


  DisplayForOrderWithReplace  = (data) => {
    this.setState({ modalOrderWithReplaceDisplay: false});
    this.DisplayForOrder(data);
  }

  DisplayForOrder = (data) => {
      const { currentSearchObj }  = this.props;
      const { personData }  = this.props;
      const { nofeshService } = this.props;
      let placeOrderData = {};

      const {token} = getToken(); 

      placeOrderData.EmployeeCardNum= token;
      placeOrderData.EmployeeIdNum= personData.EmployeeIdNum;
      placeOrderData.hotelForOrder = data.hotelForOrder;
      placeOrderData.search_param_num_family_adulds = currentSearchObj.search_param_num_family_adulds;
      placeOrderData.search_param_num_family_children = currentSearchObj.search_param_num_family_children;
      placeOrderData.search_param_num_family_babies = currentSearchObj.search_param_num_family_babies;
      placeOrderData.searchFieldGuests_placeholder = currentSearchObj.searchFieldGuests_placeholder;
      placeOrderData.vacationSelectedCycleYear = currentSearchObj.vacationSelectedCycleYear;
      this.setState({placeOrderData: placeOrderData});
      this.setState({loading:true});  
      if( data.replaceOrder != undefined) {
        placeOrderData.replaceOrder = data.replaceOrder;
      }


      console.log('Results Page DisplayForOrder before nofeshService.placeOrder this.props', this.props);

      nofeshService.placeOrder(placeOrderData).then( res  => {    
        
        console.log('ResultsPage DisplayForOrder  nofeshService.placeOrder data', res.data);

        this.setState({placeOrderDataResult: res.data});
        this.setState({loading:false}); 

        if (this.state.placeOrderDataResult == 1) {
          this.setModalOrderOpened();
        } 
        if (this.state.placeOrderDataResult == 2) {
          this.setModalOrderWithReplaceOpened();
          return;
        } 
        if ( this.state.placeOrderDataResult == -1) {
          this.setState({ modalPlaceOrderNotValid: true});
        }

        if ( this.state.placeOrderDataResult == -2) {
          this.setState({ modalPlaceOrderNotValid2: true});
        }

        if ( this.state.placeOrderDataResult == -3) {
          this.setState({ modalPlaceOrderNotValid2: true});
        }
             
      }); 
  }



  doOrder = (data) => {
      const { personData }  = this.props;
      const { nofeshService } = this.props;
      const { currentSearchObj }  = this.props;


      let makeOrderData = {};
      const {token} = getToken();


      makeOrderData.EmployeeCardNum= token;
      makeOrderData.EmployeeIdNum= personData.EmployeeIdNum;
      makeOrderData.LastName= personData.last_name;
      makeOrderData.FirstName= personData.first_name;
      makeOrderData.hotelForOrder = data.hotelForOrder;
      makeOrderData.HasConnectionDoor = data.HasConnectionDoor;
      makeOrderData.IsCouplingRooms = data.IsCouplingRooms;

      makeOrderData.personsChildren = currentSearchObj.personsChildren;
      makeOrderData.EntitlementYear = currentSearchObj.vacationSelectedCycleYear;
      makeOrderData.search_param_num_family_adulds = data.search_param_num_family_adulds;
      makeOrderData.search_param_num_family_children = data.search_param_num_family_children;

      this.setState({loading:true});  
      this.setState({makeOrderData: makeOrderData}); 

      nofeshService.makeOrder(makeOrderData).then( res  => {      

        console.log('ResultsPage  nofeshService.makeOrder data', res.data);
        
        if (this.state.makeOrderDataResult != 0) {
            if (res.data.orderId == 0) {
              this.setState({loading:false});
              this.setState({ redirect: "/emsg" }); 
            }
            this.setState({makeOrderDataResult: res.data});
            this.setState({modalOrderConfirmationDisplay:true}); 
            this.setState({modalOrderDisplay:false}); 
            this.setState({loading:false}); 
            
        } else {
          this.setState({loading:false});
          this.setState({ redirect: "/emsg" }); 
        }             
      }).catch(function(e) {
        this.setState({loading:false});
        console.error(e.message); 
      });  
  }



  setModalHotelDisplayClosed = () => {
    this.setState({ modalHotelDisplay: false});
  }

  DisplayForHotelDetails = (hotelId) => {
      this.setState({loading:true});  
      console.log('HotelsList DisplayForHotelDetails hotelId', hotelId);
      const { nofeshService } = this.props;

      nofeshService.getHotelDetails(hotelId).then( res  => {    
          console.log('DisplayForHotelDetails getHotelDetails res',res);

          this.setState({ currentHotel: res.data.hotel });
          this.setState({ currentFacilities: res.data.facilities });
          this.setState({ modalHotelDisplay: true });
          this.setState({loading:false});             
      }).catch(function(e) {
        this.setState({loading:false});
        console.error(e.message); 
      }); 
  }

  render() {         

        
    if (this.state.redirect) {        
      return <Redirect to={this.state.redirect} />
    } 

    return (      
        <div>                                   
            <div className="hp_banner">
                <UpperMenu  
                      personData={this.props.personData}
                      onLoggedOutRefresh={this.props.onLoggedOutRefresh} />

                {(!this.state.modalOrderConfirmationDisplay) ? 
                <SearchPanelResults  
                    personData={this.props.personData}
                    currentSearchObj={this.props.currentSearchObj}
                    loading={this.state.loading}
                />
                : null} 
            </div>

            {(this.state.modalOrderDisplay) ?    
                <ModalOrder  
                  personData={this.props.personData} 
                  setModalOrderClosed={this.setModalOrderClosed}
                  placeOrderData={this.state.placeOrderData}
                  doOrder={this.doOrder}
                  />
              : null}

              {(this.state.modalOrderConfirmationDisplay) ?    
                <ModalOrderConfirmation  
                    makeOrderData={this.state.makeOrderData}
                    orderId={this.state.makeOrderDataResult}
                    makeOrderDataResult={this.state.makeOrderDataResult}
                    setModalOrderConfirmationClosed={this.setModalOrderConfirmationClosed}
                  />
                : null} 


                
              {(this.state.modalPlaceOrderNotValid) ?    
                <ModalPlaceOrderNotValid 
                    placeOrderData={this.state.placeOrderData}
                    setModalPlaceOrderNotValidClosed={this.setModalPlaceOrderNotValidClosed}
                  />
                : null} 

              {(this.state.modalPlaceOrderNotValid2) ?    
                <ModalPlaceOrderNotValid2
                    placeOrderData={this.state.placeOrderData}
                    setModalPlaceOrderNotValidClosed2={this.setModalPlaceOrderNotValidClosed2}
                  />
                : null} 


                {(this.state.modalOrderWithReplaceDisplay) ?    
                  <ModalPlaceOrderWithReplace
                      placeOrderData={this.state.placeOrderData}
                      setModalOrderWithReplaceClosed={this.setModalOrderWithReplaceClosed}
                      DisplayForOrderWithReplace={this.DisplayForOrderWithReplace}
                    />
                : null}

              {(this.state.modalHotelDisplay && this.state.currentHotel) ?     
                    <ModalHotelDetails 
                        hotel={this.state.currentHotel}
                        facilities={this.state.currentFacilities}
                        setModalHotelDisplayClosed={this.setModalHotelDisplayClosed} >
                    </ModalHotelDetails>
                  :null}          

    
            <div className="hp_container">  

                {(this.state.loading) ?
                  <div className="hp_section_container">
                    <div className="cntered-flex directionRtl paddingBottom10">
                      טוען נתונים ...
                      <Spinner
                          as="span"
                          animation="border"
                          role="status"
                          aria-hidden="true"                                        
                      />      
                    </div>
                  </div>  
                : 
                  <div className="hp_section_container">
                    <TitleListHotels titleListHotels={this.state.searchTitle} />
                    <HotelsForOrderList  
                        hotelsForOrder={this.state.hotelsForOrder}  
                        DisplayForOrder={this.DisplayForOrder}
                        DisplayForHotelDetails={this.DisplayForHotelDetails}  
                      />
                  </div>  
    
                }
            </div>

            <div className="hp_footer">
            </div>
        </div>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(ResultsPage);
